export const VEHICLE_CATEGORY_COLLECTION_PATH = '/config/tenant/vehicleCategory';
export const VEHICLE_TYPE_COLLECTION_PATH = '/config/tenant/vehicleCategory/1001/vehicleType';
export const getVehicleTypeCollectionPath = (vehicleCategoryId) => `/config/tenant/vehicleCategory/${vehicleCategoryId}/vehicleType`;

export const BOOKING_COLLECTION_PATH = 'booking';
export const getBookingCollectionPathWithBookingId = (bookingId) => `booking/${bookingId}`;
export const FEEDBACK_COLLECTION_PATH = 'userFeedback';
export const USERS_COLLECTION_PATH = 'users';